import { Layout, FetchCounterValue as FetchCounterValueComponent } from "components"

export const FetchCounterValue = () => {
 return (
  <Layout>
   <FetchCounterValueComponent />
  </Layout>
 )
}
